import kr from "./kr.json";
import ja from "./ja.json";
import en from "./en.json";

export const notificationLocales = { en, ja, kr };
